// Bilingual (EN / HI) 30-day diabetic (sugar patient) diet plan.
// Rendered via useLang().tr() in <MealPlan /> when goal === 'diabetic'.

export const diabeticPlan = [
  {
    day: 1,
    meals: [
      { key: 'breakfast', label: { en: 'Breakfast', hi: 'नाश्ता' }, name: { en: 'Vegetable oats + boiled egg (or paneer)', hi: 'वेज ओट्स + उबला अंडा (या पनीर)' } },
      { key: 'midMorning', label: { en: 'Snack', hi: 'स्नैक' }, name: { en: 'Guava', hi: 'अमरूद' } },
      { key: 'lunch', label: { en: 'Lunch', hi: 'दोपहर का भोजन' }, name: { en: '2 rotis + dal + mixed vegetables + salad', hi: '2 रोटी + दाल + मिक्स सब्ज़ी + सलाद' } },
      { key: 'eveningSnack', label: { en: 'Snack', hi: 'स्नैक' }, name: { en: 'Roasted chana', hi: 'भुना चना' } },
      { key: 'dinner', label: { en: 'Dinner', hi: 'रात का भोजन' }, name: { en: 'Grilled chicken/fish or paneer + vegetables', hi: 'ग्रिल्ड चिकन/मछली या पनीर + सब्ज़ियाँ' } },
    ],
  },
  {
    day: 2,
    meals: [
      { key: 'breakfast', label: { en: 'Breakfast', hi: 'नाश्ता' }, name: { en: '2 moong dal chillas + curd', hi: '2 मूँग दाल चीला + दही' } },
      { key: 'midMorning', label: { en: 'Snack', hi: 'स्नैक' }, name: { en: 'Apple', hi: 'सेब' } },
      { key: 'lunch', label: { en: 'Lunch', hi: 'दोपहर का भोजन' }, name: { en: 'Brown rice + rajma + salad', hi: 'ब्राउन राइस + राजमा + सलाद' } },
      { key: 'eveningSnack', label: { en: 'Snack', hi: 'स्नैक' }, name: { en: 'Almonds (6)', hi: 'बादाम (6)' } },
      { key: 'dinner', label: { en: 'Dinner', hi: 'रात का भोजन' }, name: { en: '2 rotis + palak paneer', hi: '2 रोटी + पालक पनीर' } },
    ],
  },
  {
    day: 3,
    meals: [
      { key: 'breakfast', label: { en: 'Breakfast', hi: 'नाश्ता' }, name: { en: 'Vegetable upma', hi: 'वेज उपमा' } },
      { key: 'midMorning', label: { en: 'Snack', hi: 'स्नैक' }, name: { en: 'Orange', hi: 'संतरा' } },
      { key: 'lunch', label: { en: 'Lunch', hi: 'दोपहर का भोजन' }, name: { en: '2 rotis + chana masala', hi: '2 रोटी + चना मसाला' } },
      { key: 'eveningSnack', label: { en: 'Snack', hi: 'स्नैक' }, name: { en: 'Sprouts', hi: 'स्प्राउट्स' } },
      { key: 'dinner', label: { en: 'Dinner', hi: 'रात का भोजन' }, name: { en: 'Grilled fish/chicken + sautéed vegetables', hi: 'ग्रिल्ड मछली/चिकन + सौते सब्ज़ियाँ' } },
    ],
  },
  {
    day: 4,
    meals: [
      { key: 'breakfast', label: { en: 'Breakfast', hi: 'नाश्ता' }, name: { en: 'Vegetable poha', hi: 'वेज पोहा' } },
      { key: 'midMorning', label: { en: 'Snack', hi: 'स्नैक' }, name: { en: 'Pear', hi: 'नाशपाती' } },
      { key: 'lunch', label: { en: 'Lunch', hi: 'दोपहर का भोजन' }, name: { en: 'Millet roti + dal + bhindi', hi: 'बाजरा/मिलेट रोटी + दाल + भिंडी' } },
      { key: 'eveningSnack', label: { en: 'Snack', hi: 'स्नैक' }, name: { en: 'Walnuts (2–3)', hi: 'अखरोट (2–3)' } },
      { key: 'dinner', label: { en: 'Dinner', hi: 'रात का भोजन' }, name: { en: 'Paneer bhurji + salad', hi: 'पनीर भुर्जी + सलाद' } },
    ],
  },
  {
    day: 5,
    meals: [
      { key: 'breakfast', label: { en: 'Breakfast', hi: 'नाश्ता' }, name: { en: 'Besan chilla + curd', hi: 'बेसन चीला + दही' } },
      { key: 'midMorning', label: { en: 'Snack', hi: 'स्नैक' }, name: { en: 'Cucumber', hi: 'खीरा' } },
      { key: 'lunch', label: { en: 'Lunch', hi: 'दोपहर का भोजन' }, name: { en: 'Brown rice + mixed dal', hi: 'ब्राउन राइस + मिक्स दाल' } },
      { key: 'eveningSnack', label: { en: 'Snack', hi: 'स्नैक' }, name: { en: 'Roasted peanuts (small handful)', hi: 'भुनी मूँगफली (मुट्ठी भर)' } },
      { key: 'dinner', label: { en: 'Dinner', hi: 'रात का भोजन' }, name: { en: 'Chicken soup + vegetables', hi: 'चिकन सूप + सब्ज़ियाँ' } },
    ],
  },
  {
    day: 6,
    meals: [
      { key: 'breakfast', label: { en: 'Breakfast', hi: 'नाश्ता' }, name: { en: 'Vegetable omelet (or tofu scramble)', hi: 'वेज ऑमलेट (या टोफ़ू स्क्रैम्बल)' } },
      { key: 'midMorning', label: { en: 'Snack', hi: 'स्नैक' }, name: { en: 'Apple', hi: 'सेब' } },
      { key: 'lunch', label: { en: 'Lunch', hi: 'दोपहर का भोजन' }, name: { en: '2 rotis + lauki sabzi + dal', hi: '2 रोटी + लौकी सब्ज़ी + दाल' } },
      { key: 'eveningSnack', label: { en: 'Snack', hi: 'स्नैक' }, name: { en: 'Buttermilk (unsweetened)', hi: 'छाछ (बिना चीनी)' } },
      { key: 'dinner', label: { en: 'Dinner', hi: 'रात का भोजन' }, name: { en: 'Grilled paneer + broccoli', hi: 'ग्रिल्ड पनीर + ब्रोकोली' } },
    ],
  },
  {
    day: 7,
    meals: [
      { key: 'breakfast', label: { en: 'Breakfast', hi: 'नाश्ता' }, name: { en: 'Idli (2) + sambar', hi: 'इडली (2) + सांबर' } },
      { key: 'midMorning', label: { en: 'Snack', hi: 'स्नैक' }, name: { en: 'Guava', hi: 'अमरूद' } },
      { key: 'lunch', label: { en: 'Lunch', hi: 'दोपहर का भोजन' }, name: { en: '2 rotis + soybean curry', hi: '2 रोटी + सोयाबीन करी' } },
      { key: 'eveningSnack', label: { en: 'Snack', hi: 'स्नैक' }, name: { en: 'Sprouts', hi: 'स्प्राउट्स' } },
      { key: 'dinner', label: { en: 'Dinner', hi: 'रात का भोजन' }, name: { en: 'Fish/chicken + salad', hi: 'मछली/चिकन + सलाद' } },
    ],
  },
];

// Rotation guidance for weeks 2-4
export const diabeticWeekRotations = [
  {
    weekLabel: { en: 'Week 2 (Days 8–14)', hi: 'सप्ताह 2 (दिन 8–14)' },
    intro: { en: 'Repeat the same meal pattern with these changes:', hi: 'उसी भोजन पैटर्न को इन बदलावों के साथ दोहराएँ:' },
    bullets: [
      { en: 'Rotate vegetables (cauliflower, cabbage, spinach, beans, bottle gourd).', hi: 'सब्ज़ियाँ बदलें (फूलगोभी, पत्तागोभी, पालक, बीन्स, लौकी)।' },
      { en: 'Rotate proteins (paneer, tofu, eggs, chicken, fish, dal, rajma, chana).', hi: 'प्रोटीन बदलें (पनीर, टोफ़ू, अंडे, चिकन, मछली, दाल, राजमा, चना)।' },
      { en: 'Alternate between whole wheat roti, jowar roti, bajra roti, and brown rice.', hi: 'गेहूँ, ज्वार, बाजरा रोटी और ब्राउन राइस को बदल-बदल कर लें।' },
    ],
  },
  {
    weekLabel: { en: 'Week 3 (Days 15–21)', hi: 'सप्ताह 3 (दिन 15–21)' },
    bullets: [
      { en: 'Oats, besan chilla, moong chilla, vegetable dosa, or vegetable upma for breakfast.', hi: 'नाश्ते में ओट्स, बेसन चीला, मूँग चीला, वेज डोसा, या वेज उपमा।' },
      { en: 'One low-sugar fruit daily (apple, guava, pear, orange).', hi: 'रोज़ एक कम-शुगर वाला फल (सेब, अमरूद, नाशपाती, संतरा)।' },
      { en: 'Lunch: 2 rotis + dal + vegetables + salad.', hi: 'दोपहर: 2 रोटी + दाल + सब्ज़ी + सलाद।' },
      { en: 'Dinner: High-protein meal (paneer, tofu, fish, chicken, or eggs) with vegetables.', hi: 'रात: उच्च-प्रोटीन भोजन (पनीर, टोफ़ू, मछली, चिकन या अंडे) सब्ज़ियों के साथ।' },
    ],
  },
  {
    weekLabel: { en: 'Week 4 (Days 22–30)', hi: 'सप्ताह 4 (दिन 22–30)' },
    bullets: [
      { en: 'Continue the same structure while changing vegetables and protein sources to add variety.', hi: 'वही ढाँचा जारी रखें, विविधता के लिए सब्ज़ियाँ व प्रोटीन बदलते रहें।' },
      { en: 'Avoid repeating the exact same meal every day.', hi: 'हर दिन बिल्कुल वही भोजन दोहराने से बचें।' },
    ],
  },
];

export const diabeticInclude = {
  title: { en: 'Foods to include', hi: 'शामिल करने योग्य भोजन' },
  items: [
    { en: 'Whole wheat, oats, jowar, bajra, brown rice', hi: 'गेहूँ, ओट्स, ज्वार, बाजरा, ब्राउन राइस' },
    { en: 'Dal, rajma, chana, sprouts', hi: 'दाल, राजमा, चना, स्प्राउट्स' },
    { en: 'Paneer, tofu, eggs, fish, skinless chicken', hi: 'पनीर, टोफ़ू, अंडे, मछली, बिना त्वचा वाला चिकन' },
    { en: 'Green leafy vegetables', hi: 'हरी पत्तेदार सब्ज़ियाँ' },
    { en: 'Guava, apple, pear, berries, orange (in moderation)', hi: 'अमरूद, सेब, नाशपाती, बेरीज़, संतरा (सीमित मात्रा में)' },
    { en: 'Almonds and walnuts in small portions', hi: 'बादाम व अखरोट, थोड़ी मात्रा में' },
  ],
};

export const diabeticAvoid = {
  title: { en: 'Foods to avoid', hi: 'बचने योग्य भोजन' },
  items: [
    { en: 'Sugar, sweets, sweetened beverages', hi: 'चीनी, मिठाइयाँ, मीठे पेय' },
    { en: 'White bread, refined flour (maida)', hi: 'व्हाइट ब्रेड, मैदा' },
    { en: 'Fried snacks and fast food', hi: 'तला-भुना स्नैक व फ़ास्ट फ़ूड' },
    { en: 'Bakery items and sugary desserts', hi: 'बेकरी उत्पाद व मीठी मिठाइयाँ' },
  ],
};

export const diabeticLifestyle = {
  title: { en: 'Lifestyle', hi: 'जीवनशैली' },
  items: [
    { en: 'Walk 30–45 minutes daily or as advised by your doctor.', hi: 'रोज़ 30–45 मिनट टहलें, या डॉक्टर की सलाह अनुसार।' },
    { en: 'Drink 2–3 litres of water unless you have been told to limit fluids.', hi: 'रोज़ 2–3 लीटर पानी पिएँ, जब तक डॉक्टर ने तरल कम करने को न कहा हो।' },
    { en: 'Eat meals at the same time each day.', hi: 'हर दिन एक ही समय पर भोजन करें।' },
    { en: 'Check blood sugar regularly and take medications as prescribed.', hi: 'नियमित रूप से शुगर जाँचें और दवाइयाँ निर्धारित अनुसार लें।' },
  ],
};

export const diabeticDisclaimer = {
  en: 'This is a general low-sugar plan for adults with type 2 diabetes or pre-diabetes. Always follow your endocrinologist / dietitian, especially regarding insulin, medications, portion sizes, and any co-existing conditions (kidney, heart, pregnancy).',
  hi: 'यह टाइप 2 डायबिटीज़ या प्री-डायबिटीज़ वाले वयस्कों के लिए एक सामान्य कम-शुगर प्लान है। इंसुलिन, दवाइयों, पोर्शन साइज़ और किसी भी सह-मौजूदा स्थिति (गुर्दा, हृदय, गर्भावस्था) पर हमेशा अपने एंडोक्रिनोलॉजिस्ट/डाइटिशियन की सलाह मानें।',
};
